import { render } from "./Index.vue?vue&type=template&id=181b6043&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=181b6043&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181b6043"],['__file',"components/Pages/FAQ/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "181b6043"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('181b6043', __exports__)) {
    api.reload('181b6043', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=181b6043&scoped=true", () => {
    api.rerender('181b6043', render)
  })

}


export default __exports__